module.exports = __webpack_public_path__ + "static/media/whatsapp-full.a9c3592f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/whatsapp-full.svg
// module id = 764
// module chunks = 0